/*jshint esversion: 6 */
import store from '@/store/index';

function ProjectTaktPlan(payload) {
  let route = {
      path: 'taktplan',
      name: 'ProjectTaktPlan',
      component: () => {
        if (store.getters['View/isMobile']) {
          return import( /* webpackChunkName: "ProjectTaktPlan" */ '@/views/Project/ProjectTaktPlanMobile/ProjectTaktPlanMobile.view.vue')
        } else {
          return import( /* webpackChunkName: "ProjectTaktPlan" */ '@/views/Project/ProjectTaktPlan/ProjectTaktPlan.view.vue')
        }
      },
      props: (route) => {
        return {
          project_id: parseInt(route.params.project_id),
          project: store.state.Ultra.projects[route.params.project_id],
          milestone_id: parseInt(route.params.milestone_id),
          // snackbar: store.state.SnackBar.snackbar,
          selected_wp: parseInt(route.params.tworkpackage_id),
        };
      },
      meta: {
        requiresAuth: true
      },
      beforeEnter: (to, from, next) => {
        if (to.params.open_cloudprint) {
          store.state.Auth.cloudprint_cache.settings.trains_open.forEach(train_id => {
            store.dispatch('UltraDev/updateUDObject', {
              url: [
                {trains: train_id}
              ],
              update: {
                closed: false
              }
            });
          });
        }
        next();
      }
    };
    if (payload && payload.children) {
      route.children = payload.children;
    }
  return route;
}
export default ProjectTaktPlan;
